import React, { Dispatch } from 'react'

import DataController, { resultForKey } from './controllers/DataController'
import { IPartyNumberMap } from './models/TypeHelper'

import './vendor/bootstrap/scss/bootstrap.scss'
import './App.scss'
import GeographicalMap from './components/Displays/Map/GeographicalMap'
import Header from './components/Header/Header'
import Loading from './components/Helpers/Loading'
import { connect } from 'react-redux'
import { IReduxAction, IReduxState } from './utils/ReduxStore'
import TabularResults from './components/Tables/TabularResults'
import AboutModal from './components/About/AboutModal'
import ComparisonSelect from './components/Header/Compare/ComparisonSelect'
import InsightsWrapper from './components/Insights/InsightsWrapper'
import LegislatureDiagram from './components/Legislature/LegislatureDiagram'

export interface IRegionalPollMap {
  [key: string]: IPartyNumberMap
}

interface IDispatchProps {
  initialized: () => void
}

interface IStateProps {
  baseResultKey: string
  compareResultKey: string
  resultDisplayMode: string
  lastReset: number
}

interface IProps extends IDispatchProps, IStateProps {}

class App extends React.Component<IProps> {
  public async componentDidMount(): Promise<void> {
    await DataController.instance().initialize(true)
    console.log('App mounted and data loaded.')
    this.props.initialized()
  }

  public render(): JSX.Element {
    const nationalResult = resultForKey(this.props.baseResultKey)
    const resultDisplayMode = this.props.resultDisplayMode

    const isLoading = !nationalResult

    if (isLoading) {
      return <Loading />
    }

    return (
      <div className="AppContainer">
        <AboutModal />
        <div className="App container-fluid">
          <Header />
          <ComparisonSelect />
          <div className="row MainArea">
            <div className="col">
              {resultDisplayMode === 'geographicalMap' && <GeographicalMap />}
              {resultDisplayMode === 'tables' && <TabularResults />}
              {resultDisplayMode === 'legislature' && <LegislatureDiagram />}
              {resultDisplayMode === 'insights' && <InsightsWrapper />}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IReduxState): IStateProps => ({
  baseResultKey: state.baseResultKey,
  compareResultKey: state.compareResultKey,
  resultDisplayMode: state.resultDisplayMode,
  lastReset: state.lastReset
})

const mapDispatchToProps = (
  dispatch: Dispatch<IReduxAction>
): IDispatchProps => ({
  initialized: (): void => {
    dispatch({ type: 'INITIALIZED' })
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
